import Card from '../card'
export default Card.Body



// WEBPACK FOOTER //
// ./src/components/card-body/index.js